import { Game } from '@repo/types'
import { ToggleSwitch } from '@repo/ui'
import { observer } from 'mobx-react-lite'
import React from 'react'

import { useGameContext } from '@/pages/game/context/game-context'
import { updateGameSetting } from '@/store/game/updateGameDocument'

import { SettingsRow } from '../SettingsRow'

const SETTING_NAME = 'Brand Image'
const SETTING_ID = 'jumbotron.enableBrandImage' as const

export const EnableJumbotronBrandImage = observer(
  function EnableJumbotronBrandImage(): React.ReactElement {
    const { gameData, gameId, tracker } = useGameContext()

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const { checked } = event.target

      const update: Pick<Game, typeof SETTING_ID> = {
        [SETTING_ID]: checked
      }

      void updateGameSetting(gameId, update)
      tracker.changeToggle(`Jumbotron ${SETTING_NAME}`, checked)
    }

    return (
      <SettingsRow description='Show brand image on screen.' heading={SETTING_NAME}>
        <ToggleSwitch
          id={SETTING_ID}
          isChecked={gameData.jumbotron.enableBrandImage}
          onChange={handleChange}
        />
      </SettingsRow>
    )
  }
)
